import { ButtonIcon, MenuContent, MenuRoot, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { IChallenge } from 'features/challenge/config/types';
import {
  PlanningDraftSprintMenuEditButton,
  PlanningDraftSprintMenuRemoveButton,
  IPlanningDraftSprint,
} from 'features/planning';

type TPlanningChallengeCardMenu = {
  challenge: IChallenge | ChallengeTimelineItemType;
  sprint: IPlanningDraftSprint;
};

export const PlanningDraftSprintsItemMenu = ({
  challenge,
  sprint,
}: TPlanningChallengeCardMenu) => (
  <MenuRoot placement="bottom-end" offset={[-10, 0]} autoSelect={false}>
    <MenuTrigger asChild>
      <ButtonIcon aria-label="Options" size="sm" variant="ghost">
        <Icon name={iconNames.ellipsisHorizontal} />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent p="0">
      <Spacer size="sm" />
      <PlanningDraftSprintMenuEditButton
        sprint={sprint}
        challenge={challenge}
      />
      <PlanningDraftSprintMenuRemoveButton
        sprint={sprint}
        challengeId={challenge.challengeId!}
      />
      <Spacer size="sm" />
    </MenuContent>
  </MenuRoot>
);
